import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'

import { Helmet } from 'react-helmet-async'

const TitleAnnouncer = () => {
  const [title, setTitle] = useState('')
  const titleRef = useRef<HTMLParagraphElement>(null)
  const { pathname } = useLocation()

  useEffect(() => {
    if (titleRef.current) titleRef?.current?.focus()
  }, [pathname])

  return (
    <>
      <p tabIndex={-1} ref={titleRef} className={'visually-hidden'}>
        {title}
      </p>
      <Helmet onChangeClientState={({ title }) => setTitle(title)} />
    </>
  )
}

export default TitleAnnouncer
